import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sin protocolo de intervención',
    cost: 'Quedás expuesto cuando el campo se detiene'
  }, {
    without: 'Sin seguimiento documentado',
    cost: 'Cada sesión sin continuidad ni hilo conductor'
  }, {
    without: 'Sin frases sanadoras clasificadas',
    cost: 'Improvisás las palabras más importantes del proceso'
  }, {
    without: 'Sin ficha clínica profesional',
    cost: 'Procesos sin registro que no generan confianza'
  }, {
    without: 'Sin Maestría en Consulta',
    cost: 'Seguís esperando que la profundidad llegue sola'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de improvisación, la próxima semana'
  }];
  return <Section data-id="element-16" data-mp="1e7rsd4mdwm9w">
      <div className="text-center mb-12" data-id="element-17" data-mp="1e7i2dh1caf47"></div>

      <div className="max-w-4xl mx-auto" data-id="element-18" data-mp="196kjt3cf3j26">
        <div className="hidden md:block" data-id="element-19" data-mp="195sntrewrjbd">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-20" data-mp="2lb2a25hfgzyn">
            <div className="font-serif font-bold text-lg text-brand-violet" data-id="element-21" data-mp="2lbkazff1c2cw">
              Sin Vademécum
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-22" data-mp="2bclf6xfdc17b">
              Costo Real
            </div>
          </div>
          <div className="space-y-3" data-id="element-23" data-mp="2gawlwzad9vlb">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-24" data-mp="21n1s1fkmhl6n" data-mpi={i}>
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-25" data-mp="1sm3rj79e7vst">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-26" data-mp="1xm9l4sz83sdj">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>
      </div>

      <div className="text-center mt-10" data-id="element-27" data-mp="1nlz5l1ppu8v7">
        <p className="text-lg md:text-2xl font-display italic font-[600] text-brand-violetDark" data-id="element-28" data-mp="1np4tweqit6pv">
          "El terapeuta que tiene un sistema, trabaja con confianza. El que
          trabaja con confianza, genera resultados. El que genera resultados,
          crece." 🌿
        </p>
      </div>
    </Section>;
};